import { isSSR } from '@helpers/ssr';
import useBodyScrollLock from '@hooks/useBodyScrollLock';
import { FocusScope } from '@react-aria/focus';
import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Background from './Background/Background';
import Close from './Close/Close';
import { ModalProvider } from './Context/Context';
import S from './Modal.styles';
const Modal = (props) => {
    const refContainer = useBodyScrollLock(props.isOpen);
    if (isSSR()) {
        return null;
    }
    // Use #root if available, otherwise fallback to body.
    const portalContainer = document.getElementById('root') ?? document.body;
    const portalContent = (React.createElement(ModalProvider, { closeOnBackground: props.closeOnBackground, showBackground: props.showBackground, showClose: props.showClose, onClose: props.onClose },
        React.createElement(AnimatePresence, { exitBeforeEnter: true }, props.isOpen ? (React.createElement(FocusScope, { autoFocus: true, contain: true, restoreFocus: true },
            React.createElement(S.Container, { ref: refContainer, id: props.id, role: "dialog", "aria-label": props.ariaLabel, "aria-modal": "true", onKeyDown: (event) => {
                    if (event.key === 'Escape') {
                        props.onClose();
                    }
                } },
                props.showBackground && React.createElement(Background, null),
                React.createElement(S.Inner, { variants: { open: { opacity: 1, y: 0 }, closed: { opacity: 0, y: '15%' } }, initial: "closed", animate: "open", exit: "closed" },
                    props.children,
                    props.showClose && React.createElement(Close, null))))) : null)));
    return ReactDOM.createPortal(portalContent, portalContainer);
};
export default Modal;
